import type { Block } from '@gitbook/slate';

import {
    BLOCK_COLUMNS,
    BLOCK_EXPANDABLE,
    BLOCK_HEADING_1,
    BLOCK_HEADING_2,
    BLOCK_HEADING_3,
    BLOCK_OPENAPI,
    BLOCK_OPENAPI_OPERATION,
    BLOCK_OPENAPI_SCHEMAS,
    BLOCK_OPENAPI_WEBHOOK,
    BLOCK_STEPPER,
    BLOCK_TABS,
    BLOCK_TABS_ITEM,
    BLOCK_UPDATE,
    BLOCK_UPDATES,
} from '../types';

const SECTION_TYPES = [
    BLOCK_HEADING_1,
    BLOCK_HEADING_2,
    BLOCK_HEADING_3,
    BLOCK_OPENAPI,
    BLOCK_OPENAPI_OPERATION,
    BLOCK_OPENAPI_SCHEMAS,
    BLOCK_OPENAPI_WEBHOOK,
    BLOCK_EXPANDABLE,
    BLOCK_TABS,
    BLOCK_TABS_ITEM,
    BLOCK_UPDATE,
] as const;

export type SectionDelimiterType = (typeof SECTION_TYPES)[number];

export type SectionDelimiterBlock = Block & { type: SectionDelimiterType };

/**
 * Test if a block should be used to delimit sections.
 */
export function isSectionDelimiter(block: Block): block is SectionDelimiterBlock {
    return SECTION_TYPES.includes(block.type);
}

/**
 * Test if a block can include sections and as such should be used to delimit sections.
 */
const SECTIONS_PARENT_TYPES = [BLOCK_STEPPER, BLOCK_COLUMNS, BLOCK_UPDATES] as const;
export type SectionDelimiterParentType = (typeof SECTIONS_PARENT_TYPES)[number];
export type SectionDelimiterParentBlock = Block & { type: SectionDelimiterParentType };

export function isSectionDelimiterParent(block: Block): block is SectionDelimiterParentBlock {
    return SECTIONS_PARENT_TYPES.includes(block.type);
}
